import React, { useState, useEffect } from 'react';
import SuppliersList from './SuppliersList';
import ViewSupplier from './ViewSupplier';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './Suppliers.css';

function Suppliers() {
  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  const [viewMode, setViewMode] = useState('list'); // 'list', 'view', 'edit', 'create'

  useEffect(() => {
    // Set toolbar based on current mode
    if (window.setToolbar) {
      if (viewMode === 'list') {
        window.setToolbar({
          title: 'Suppliers',
          buttons: [
            {
              label: 'New Supplier',
              icon: '➕',
              onClick: handleNew,
              variant: 'primary'
            },
            {
              label: 'Refresh',
              icon: '🔄',
              onClick: handleRefresh
            }
          ]
        });
      } else if (viewMode === 'view') {
        window.setToolbar({
          title: 'View Supplier',
          showBack: true,
          onBack: handleBack,
          buttons: [
            {
              label: 'Edit',
              icon: '✏️',
              onClick: handleEdit,
              variant: 'secondary'
            },
            {
              label: 'Delete',
              icon: '🗑️',
              onClick: handleDelete,
              variant: 'danger'
            }
          ]
        });
      } else if (viewMode === 'edit') {
        window.setToolbar({
          title: 'Edit Supplier',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Save',
              icon: '💾',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      } else if (viewMode === 'create') {
        window.setToolbar({
          title: 'New Supplier',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Create',
              icon: '➕',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      }
    }

    return () => {
      if (window.setToolbar) {
        window.setToolbar(null);
      }
    };
  }, [viewMode]);

  const handleSelectSupplier = (supplierId) => {
    setSelectedSupplierId(supplierId);
    setViewMode('view');
  };

  const handleNew = () => {
    setSelectedSupplierId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleDelete = () => {
    // Delete will be handled in ViewSupplier component
    if (window.viewSupplierRef && window.viewSupplierRef.handleDelete) {
      window.viewSupplierRef.handleDelete();
    }
  };

  const handleSave = () => {
    // Save will be handled in ViewSupplier component
    if (window.viewSupplierRef && window.viewSupplierRef.handleSave) {
      window.viewSupplierRef.handleSave();
    }
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedSupplierId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleBack = () => {
    setViewMode('list');
    setSelectedSupplierId(null);
  };

  const handleRefresh = () => {
    // Trigger refresh in SuppliersList
    if (window.suppliersListRef && window.suppliersListRef.fetchSuppliers) {
      window.suppliersListRef.fetchSuppliers();
    }
  };

  const handleSupplierSaved = (supplier) => {
    setSelectedSupplierId(supplier.provider_id);
    setViewMode('view');
    // Refresh the list
    if (window.suppliersListRef && window.suppliersListRef.fetchSuppliers) {
      window.suppliersListRef.fetchSuppliers();
    }
  };

  return (
    <div className="suppliers-page">
      <ResizablePanels
        leftPanel={
          <SuppliersList
            ref={ref => window.suppliersListRef = ref}
            onSelectSupplier={handleSelectSupplier}
            selectedSupplierId={selectedSupplierId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewSupplier
              ref={ref => window.viewSupplierRef = ref}
              supplierId={selectedSupplierId}
              onBack={handleBack}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onSave={handleSupplierSaved}
              onCancel={handleCancel}
              onEdit={handleEdit}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
}

export default Suppliers;